import L from 'leaflet';

export const markerIcon = (isFirst) => L.icon({
  className: 'map__marker',
  iconUrl: isFirst
    ? '/front_assets/img/map/marker-white.svg'
    : '/front_assets/img/map/marker-primary.svg',
  iconSize: [30, 40],
  iconAnchor: [15, 40],
});

/*
 * TODO: create popup
 */
export const popup = (data) => {
  const div = document.createElement('div');
  div.className = 'map__popup';
  div.setAttribute('data-target', 'map.popup');
  div.setAttribute('tabindex', '0');

  div.innerHTML = `${data}`;

  return div;
};
